// subscription dropdwan js 

document.addEventListener("DOMContentLoaded", function () {

  function initSubscriptionDropdown() {
    const widget = document.querySelector('.utterbond-subscription-widget');
    const textDiv = document.querySelector('.subscription-text');

    if (!widget || !textDiv) return;
    if (widget.closest('.subscription-wrapper')) return;

    const title = textDiv.dataset.title || 'Subscription';
    const descText = textDiv.dataset.text || '';
    const wrapper = document.createElement('div');
    wrapper.classList.add('subscription-wrapper');

    const details = document.createElement('details');
    details.classList.add('subscription-dropdown');
    details.classList.add('product-dropdwan-option');

    const summary = document.createElement('summary');
    summary.classList.add('subscription-summary');

    const titleSpan = document.createElement('span');
    titleSpan.classList.add('sub-title');
    titleSpan.textContent = title;

    const planSpan = document.createElement('span');
    planSpan.classList.add('sub-plan');

    function updatePlanText() {
    const select = document.querySelector('.ub_subscription_spg_plan_select');
    if (!select || !select.options.length) return;

    const selectedOption = select.options[select.selectedIndex] || select.options[0];
    planSpan.textContent = selectedOption.textContent.trim();
  }

  function waitForSelectAndInit() {
    const select = document.querySelector('.ub_subscription_spg_plan_select');

    if (select && select.options.length > 0) {
      updatePlanText(); 
    } else {
      setTimeout(waitForSelectAndInit, 200);
    }
  }

  waitForSelectAndInit();
    updatePlanText();

    summary.appendChild(titleSpan);
    summary.appendChild(planSpan);

    const desc = document.createElement('div');
    desc.classList.add('subscription-desc');
    desc.textContent = descText;

    details.appendChild(summary);
    details.appendChild(desc);

    widget.parentNode.insertBefore(wrapper, widget);
    wrapper.appendChild(details);
    details.appendChild(widget);

    document.addEventListener('change', function (e) {
      if (e.target.classList.contains('ub_subscription_spg_plan_select')) {
        updatePlanText();
      }
    });
  }

  initSubscriptionDropdown();
  const observer = new MutationObserver(() => {
    initSubscriptionDropdown();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

});

// count set on select product

document.addEventListener('change', function (e) {
  if (e.target.classList.contains('addon-product-checkbox')) {

    const wrapper = e.target.closest('.adon-product-cst');
    if (!wrapper) return;

    const checkboxes = wrapper.querySelectorAll('.addon-product-checkbox');
    const checked = wrapper.querySelectorAll('.addon-product-checkbox:checked');
    const countEl = wrapper.querySelector('.addon-count');

    if (!countEl) return;

    const total = checkboxes.length;
    const selected = checked.length;

    countEl.textContent = `${selected}/${total}`;
  }
});

// details toggle dropdwan on product page

document.addEventListener('click', function (e) {
  const clickedDetails = e.target.closest('.product-dropdwan-option');
  if (!clickedDetails) return;

  setTimeout(() => {
    
    if (clickedDetails.hasAttribute('open')) {

      document.querySelectorAll('.product-dropdwan-option').forEach(item => {
        if (item !== clickedDetails) {
          item.removeAttribute('open');
        }
      });

    }

  }, 0);
});

//  custom bundal code end
function custom_addtocart_fun(product,open_drawer){
  console.log("product",product);
      fetch(`${routes.cart_add_url}`,{ 
              method: 'POST',
              headers: { "Accept": "application/json", "Content-Type": "application/json" },
              body: JSON.stringify(product)
        })
        .then(response => response.json()).then(response => {     
          console.log(response);   
        })
        .catch((error) => {
          console.error('Error:', error);
        })
        .finally((e) => {
          // console.log("finally");
          if(open_drawer){
            const this_cartDrawer = document.querySelector('cart-drawer');
           // console.log("this_cartDrawer",this_cartDrawer);
            this_cartDrawer.refresh(true);
          }
        });
    }

// upsell product variant 

//subscription qty tag label
document.addEventListener("DOMContentLoaded", function () {

  function toggleBundleLabel() {

    const oneTimePurchaseInput = document.querySelector('input[value="one-time-purchase"]:checked');
    const bundleLabels = document.querySelectorAll('.kaching-bundles__bar-label');

    bundleLabels.forEach(label => {
      label.style.display = oneTimePurchaseInput ? 'none' : '';
    });
  }
  toggleBundleLabel();

  document.addEventListener('change', function (e) {
    if (e.target.matches('input[value="one-time-purchase"]')) {
      toggleBundleLabel();
    }
  });

  const observer = new MutationObserver(() => {
    toggleBundleLabel();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true
  });

});

//card product add to cart
document.addEventListener('click', function(e) {
  const option = e.target.closest('.card_option');
  if (!option) return;

  const wrapper = option.closest('.product-variant');

  wrapper.querySelectorAll('.card_option').forEach(el => {
    el.classList.remove('active');
  });

  option.classList.add('active');

  const card = option.closest('.card-wrapper');
  const variantInput = card?.querySelector('input[name="id"]');

  if (variantInput) {
    variantInput.value = option.dataset.variantId;
  }

  console.log('Selected Variant:', option.dataset.variantId);
});

document.addEventListener('click', async function(e) {
  const btn = e.target.closest('.card-add-to-cart');
  if (!btn) return;

  e.preventDefault();

  const card = btn.closest('.card-wrapper');
  const activeVariant = card?.querySelector('.card_option.active');

  if (!activeVariant) {
    alert('Please select a variant');
    return;
  }

  const variantId = activeVariant.dataset.variantId;

  console.log('Adding Variant:', variantId);

  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1
      })
    });

    if (!response.ok) {
      throw new Error('Add to cart failed');
    }

    document.dispatchEvent(
      new CustomEvent('cart:refresh', {
        bubbles: true
      })
    );

  } catch (error) {
    console.error(error);
  }
});